import { Injectable } from '@angular/core'
import { Meta, Title } from '@angular/platform-browser'
import { PageMetaService } from '@spartacus/core'
import { SeoMetaService } from '@spartacus/storefront'
import {
  EbAlternateLink,
  EBOGPMetaData,
  EbPageMeta,
  EBStructuredProductData
} from '../cms/interfaces/eb-page.interface'
import { EbPageMetaLinkService } from './eb-page-meta-link.service'

@Injectable({
  providedIn: 'root'
})
export class EbSeoMetaService extends SeoMetaService {
  constructor(
    protected ngTitle: Title,
    protected ngMeta: Meta,
    protected pageMetaService: PageMetaService,
    protected pageMetaLinkService?: EbPageMetaLinkService
  ) {
    super(ngTitle, ngMeta, pageMetaService, pageMetaLinkService)
  }

  protected set meta(meta: EbPageMeta) {
    this.title = meta.title
    this.description = meta.description
    this.image = meta.image
    this.robots = meta.robots
    this.canonicalUrl = meta.canonicalUrl
    this.setAlternateLinks = meta.alternates
    this.setStructuredProductMetaData = meta.structuredData
    this.setMetaDataForOpenGraphProtocol = meta.ogpMetaData
  }

  protected set setAlternateLinks(alternates: EbAlternateLink[] | undefined) {
    this.pageMetaLinkService?.setAlternateLinks(alternates)
  }

  protected set setStructuredProductMetaData(structuredData: EBStructuredProductData | undefined) {
    this.pageMetaLinkService?.setStructuredProductMetaData(structuredData)
  }

  protected set setMetaDataForOpenGraphProtocol(metaData: EBOGPMetaData | undefined) {
    this.pageMetaLinkService?.setOGPMetaData(metaData)
  }
}
